import { t } from 'ttag';
import {
  FlipBackDefinition,
  FlipCardDefinition,
  FlipFrontDefinition,
  FLIP_BACK,
  FLIP_CARD,
  FLIP_FRONT,
  LayoutGridDefinition,
  LayoutListDefinition,
  LAYOUT_GRID,
  LAYOUT_LIST,
  TEXT,
  TWEET,
  TWEET_LOCK
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { useEditorStore } from '~/shell/Store';

export const SocialMedia12: Translator = sequence => {
  const cardsList = {
    type: LAYOUT_GRID,
    id: `${sequence.id}-card`,
    items: [],
    values: {
      gridTemplateColumns: {
        _: 'minmax(0, 1fr)',
        lg: 'repeat(2, minmax(0, 1fr))'
      },
      gridAutoFlow: 'row'
    }
  } as LayoutGridDefinition;

  const isFlipType = sequence.items?.some(
    item => item.__typename === 'Card' && item.variant === 'flip'
  );

  let cardIndex = 0;
  /*
  In this template we are using the card index to display the card position if we have FLIP variant.
  We can't use the item.position because when we remove a card, the position is not updated correctly.
  Also we can't use the item.disappear because we don't have options to set the disappear position.
  */

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Card':
        cardIndex++;

        cardsList.items.push({
          id: item.id,
          type: FLIP_CARD,
          values: {
            width: '98%',
            padding: '0',
            showSubtitle: true,
            showTitle: true,
            cardTitle: item.title
          },
          items: [
            {
              id: `${item.id}.front`,
              type: FLIP_FRONT,
              items: [
                {
                  id: `${item.id}.front-list`,
                  type: LAYOUT_LIST,
                  values: {},
                  items: [
                    {
                      type: TWEET,
                      id: `tweet-${item.id}`,
                      values: {
                        pic:
                          sequence.personalization && sequence.logoUrl
                            ? sequence.logoUrl
                            : item?.pictures && item?.pictures.length >= 0
                              ? item?.pictures[0]?.mediaUrl
                              : false,
                        name: item.title,
                        alias: item.subtitle,
                        width: '100%',
                        height: '100%'
                      },
                      items: [
                        {
                          type: TEXT,
                          id: 'tweet_body',
                          items: [],
                          values: {
                            value:
                              item.body?.replace(/<b><\/b><br><br>/g, '') ??
                              item.body,
                            editable: false
                          }
                        }
                      ]
                    }
                  ]
                } as LayoutListDefinition
              ]
            } as FlipFrontDefinition,
            {
              id: `${item.id}.back`,
              type: FLIP_BACK,
              items: [
                {
                  id: `${item.id}.back-list`,
                  type: LAYOUT_LIST,
                  values: {
                    padded: false
                  },
                  items: [
                    {
                      type: TWEET_LOCK,
                      id: `tweet-${item.id}`,
                      values: {
                        // text:
                        //   isFlipType && (item.disappear || item.position)
                        //     ? item.disappear || item.position
                        //     : null,
                        text: isFlipType && item.position ? cardIndex : null,
                        width: '100%',
                        height: '100%'
                      },
                      items: [
                        {
                          type: TEXT,
                          id: 'tweet_body',
                          items: [],
                          values: {
                            value: t`Click To View Post`
                          }
                        }
                      ]
                    }
                  ]
                } as LayoutListDefinition
              ]
            } as FlipBackDefinition
          ]
        } as FlipCardDefinition);
    }
    return null;
  });

  try {
    const { contentEditable } = useEditorStore.getState();

    if (contentEditable) {
      const existingCardCount = cardsList.items.filter(
        i => i.type === FLIP_CARD
      ).length;
      cardsList.items.push({
        id: `${sequence.id}.add-card-placeholder-${existingCardCount + 1}`,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        type: 'AddCardPlaceholder' as any,
        values: {
          width: '98%',
          height: '100%',
          padding: '0',
          text: t`Add a card`,
          separateTitleAndBody: false,
          showSubtitle: true,
          showTitle: true,
          backgroundColor: '#FFF'
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any);
    }
  } catch (e) {
    // silently ignore if store unavailable in this render context
  }

  root.items.push(cardsList);
  return root;
};
